<div class="main-tab-container" #mainTabContainer>
  <div class="arrow-tab-icon-left arrow-icon d-none" (click)="scrollLeft()">
    <img src="global-assets/mobi-office-ui/arrow-left.svg" alt="left-arrow" class="tab-arrow-icon" />
  </div>
  <div class="tab-container {{ tabStyle }}" #tabsContent>
    @for (item of tabs; track item; let i = $index) {
      <div class="tab {{ tabColor }}" [ngClass]="{ 'tab-active': selectedTab === item.tabValue }" (click)="onTabChange(item)">
        <!-- Delete -->
        @if (isDeletable && deleteIconPosition === "left") {
          <img
            [src]="deleteIconPath"
            [alt]="deleteIconAlt"
            class="{{ deleteIconClass }} delete-tab-icon-left"
            [matTooltip]="deleteIconToolTip"
            [matTooltipDisabled]="!deleteIconToolTip"
            (click)="onDelete(i, $event)" />
        }
        <!-- ICON -->
        @if (item.tabIconPath && iconPosition === "left") {
          <img
            [src]="item.tabIconPath"
            [alt]="iconAlt"
            class="{{ iconClass }} tab-icon-left"
            [matTooltip]="item.iconTooltip || ''"
            [matTooltipDisabled]="!item.iconTooltip"
            (click)="onIcon(item, $event)" />
        }
        <p class="tab-text">{{ item?.tabName }}</p>
        @if (item?.tabBadgeValue) {
          <div class="tab-badge {{ badgeClass }}">
            <span class="tab-badge-value">{{ item.tabBadgeValue }}</span>
          </div>
        }
        <!-- ICON -->
        @if (item.tabIconPath && iconPosition === "right") {
          <img
            [src]="item.tabIconPath"
            [alt]="iconAlt"
            class="{{ iconClass }} tab-icon-right"
            [matTooltip]="item.iconTooltip || ''"
            [matTooltipDisabled]="!item.iconTooltip"
            (click)="onIcon(item, $event)" />
        }
        <!-- Delete -->
        @if (isDeletable && deleteIconPosition === "right") {
          <img
            [src]="deleteIconPath"
            [alt]="deleteIconAlt"
            class="{{ deleteIconClass }} delete-tab-icon-right"
            [matTooltip]="deleteIconToolTip"
            [matTooltipDisabled]="!deleteIconToolTip"
            (click)="onDelete(i, $event)" />
        }
      </div>
    }
  </div>
  <div class="arrow-tab-icon-right arrow-icon d-none" (click)="scrollRight()">
    <img src="global-assets/mobi-office-ui/arrow-right.svg" alt="right-arrow" class="tab-arrow-icon" />
  </div>
</div>
